class NewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.stateEl = this.querySelector('[data-form-state]');
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();
    const submitBtn = this.form.querySelector('button[type="submit"]');
    submitBtn?.setAttribute('disabled', 'true');

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'text/html' },
      });
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newState = doc.querySelector('[data-form-state]');
      if (newState) this.stateEl.innerHTML = newState.innerHTML;
    } catch (error) {
      submitBtn?.removeAttribute('disabled');
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm);
}
